import {MinusIcon, PlusIcon} from '@heroicons/react/solid';
import {useState} from 'react';

import {Button, Table, TBody, Td, Th, Thead, Tr} from '@/components';
import type {AfriexProcessor} from '@/types';
import * as formatDate from '@/utils/date';

import ProcessorSummary from './ProcessorSummary';
import {ADMIN_FLAGS_NOTE} from './productionStatus';
import ProductionStatusBadge from './ProductionStatusBadge';

const ProcessorTable = ({items}: {items: AfriexProcessor[]}) => {
  return (
    <Table className="overflow-hidden">
      <Thead>
        <Tr>
          <Th className="w-20">&nbsp;</Th>
          <Th>Name</Th>
          <Th>Code</Th>
          <Th>Production</Th>
          <Th title={ADMIN_FLAGS_NOTE}>Admin flags</Th>
          <Th>Date</Th>
        </Tr>
      </Thead>
      <TBody>
        {items?.map((item, index) => (
          <ProcessorRow key={item.id || index} item={item} index={index} />
        ))}
      </TBody>
    </Table>
  );
};

const ProcessorRow = ({
  item,
  index,
}: {
  item: AfriexProcessor;
  index: number;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const zebraRow = index % 2 === 0 ? '' : 'bg-gray-50 dark:bg-dark-zebraRow';
  const flags = item.meta?.flags;
  const isActive = flags?.isActive && !flags?.isDeactivated && !flags?.isDown;

  return (
    <>
      <Tr className={zebraRow}>
        <Td isNumeric>
          <Button onClick={() => setIsExpanded(!isExpanded)} variant="unStyled">
            <div
              className={`border-2 border-gray-700 dark:border-dark-borderLight dark:text-gray-100 text-gray-700 w-5 h-5 flex justify-center rounded hover:bg-cyan-50 ${
                isExpanded && 'bg-cyan-50'
              }`}
            >
              {isExpanded ? (
                <MinusIcon className="w-4 h-4" />
              ) : (
                <PlusIcon className="w-4 h-4" />
              )}
            </div>
          </Button>
        </Td>
        <Td>{item?.name}</Td>
        <Td>{item?.code}</Td>
        <Td>
          <ProductionStatusBadge statuses={item.meta?.capabilityStatuses} />
        </Td>
        <Td>
          {isActive ? (
            <span className="text-green-500">Active</span>
          ) : (
            <span className="text-red-500">Inactive</span>
          )}
        </Td>
        <Td>{formatDate.DDMonYYYY(String(item.updatedAt))}</Td>
      </Tr>

      {isExpanded && (
        <Tr enableHover={false}>
          <Td colSpan={6} className="p-0">
            <div className="flex py-10 px-8 justify-center bg-sky-50 dark:bg-transparent w-full">
              <ProcessorSummary item={item} />
            </div>
          </Td>
        </Tr>
      )}
    </>
  );
};

export default ProcessorTable;
